import { ReactElement } from 'react'

type TMetaFeedback = {
  dirtySinceLastSubmit?: boolean
  error?: Error
  submitError?: Error
  touched?: boolean
}

type TReturnFeedback = {
  feedback: ReactElement
  feedbackType: string
}

export function getFeedback(meta: TMetaFeedback): TReturnFeedback {
  let feedbackType = ''
  let feedback

  const { dirtySinceLastSubmit, error, submitError, touched } = meta

  if (touched) {
    if (error || (submitError && !dirtySinceLastSubmit)) {
      feedbackType = 'invalid'
      feedback = error || submitError
    } else {
      feedbackType = 'valid'
    }
  }

  return { feedback, feedbackType }
}
